import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { Route_eCMRConditionsDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRConditionsDto';

@Component({
  selector: 'updateconditionsdialog-dialog',
  templateUrl: './updateconditionsdialog.dialog.component.html'
})
export class UpdateConditionsDialogDialogComponent {

  @Output() public onResolve: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private mdDialogRef: MatDialogRef<UpdateConditionsDialogDialogComponent>,
    private mdDialog: MatDialog,
    private ecmrController: RouteCMRController,
    private openEcmrController: OpenRouteCMRController) { }

  onClose() {
    this.onResolve.next(false);
    this.mdDialog.closeAll();
  }

  onConfirm() {
    if(!this.data.external){
      this.ecmrController.updateConditions(this.data.routePartCMRId, Route_eCMRConditionsDto.build(this.data.conditions)).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    }else{
      this.openEcmrController.updateConditions(this.data.routePartCMRId, Route_eCMRConditionsDto.build(this.data.conditions)).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    }
  }
}